import heroVideo from "../assets/herovid1.mp4";
import { motion } from "framer-motion";

export default function Hero({ onBookNow }) {
    return (
        <section
            id="hero"
            className="relative min-h-screen flex flex-col justify-center items-center text-center overflow-hidden"
        >
            {/* Background Video */}
            <video
                autoPlay
                loop
                muted
                playsInline
                className="absolute top-0 left-0 w-full h-full object-cover z-0"
            >
                <source src={heroVideo} type="video/mp4" />
            </video>

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/30 z-10 backdrop-blur-sm"></div>

            {/* Foreground Content */}
            <div className="relative z-20 px-6">
                {/* Title */}
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-Cinzel font-bold mb-4 uppercase text-white drop-shadow-[0_0_5px_rgba(0,0,0,0.8)]">
                    <span className="relative inline-block text-white drop-shadow-[0_0_2px_rgba(212,175,55,0.7)]">
                        AMANTRANAA
                    </span>{" "}
                    <span className="relative inline-block text-white drop-shadow-[0_0_2px_rgba(212,175,55,0.7)]">
                        CATERERS
                        {/* Shimmer Effect */}
                        <motion.span
                            className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/60 to-transparent opacity-50"
                            animate={{ x: ["-100%", "100%"] }}
                            transition={{
                                duration: 2.5,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "linear",
                            }}
                        />
                    </span>
                </h1>

                {/* Subtitle */}
                <p className="text-lg md:text-xl italic mb-10 text-white drop-shadow-[0_1px_5px_rgba(0,0,0,0.7)] uppercase tracking-wide">
                    An invitation to flavor, tradition & celebration
                </p>

                {/* Buttons */}
                <div className="flex flex-wrap justify-center gap-4">
                    {/* Explore Menu */}
                    <a
                        href="#menu"
                        className="relative px-6 py-3 rounded-full border-2 border-[#D4AF37] text-white font-bold uppercase overflow-hidden
              hover:bg-gradient-to-r hover:from-[#D4AF37]/30 hover:via-[#FFF9E0]/20 hover:to-[#D4AF37]/30 hover:text-[#0A1C33]
              transition-all duration-300 shadow-lg hover:shadow-[0_0_25px_rgba(212,175,55,0.5)]"
                    >
                        Explore Menu
                        <motion.span
                            className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-30"
                            animate={{ x: ["-100%", "100%"] }}
                            transition={{
                                duration: 2.5,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "linear",
                            }}
                        />
                    </a>

                    {/* Book Now */}
                    <button
                        onClick={onBookNow}
                        className="relative px-6 py-3 rounded-full bg-gradient-to-r from-[#FFD700] to-[#E8C25C] text-[#0A1C33] font-bold uppercase overflow-hidden shadow-[0_0_20px_rgba(212,175,55,0.7)]
              hover:scale-105 transition-all duration-300 hover:shadow-[0_0_35px_rgba(212,175,55,0.9)]"
                    >
                        Book Now
                        <motion.span
                            className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent opacity-40"
                            animate={{ x: ["-100%", "100%"] }}
                            transition={{
                                duration: 2.2,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "linear",
                            }}
                        />
                    </button>
                </div>
            </div>

            {/* Scroll Cue */}
            <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/80 text-sm animate-bounce drop-shadow-[0_0_5px_rgba(0,0,0,0.7)]">
                ↓ Scroll to Explore ↓
            </div>
        </section>
    );
}
